import { useState, useCallback } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const useSubmissions = (getAuthHeader) => {
  const [submissions, setSubmissions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchSubmissions = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`${API_URL}/api/admin/submissions`, {
        headers: {
          'Authorization': getAuthHeader()
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        setSubmissions(data.submissions || []);
      } else {
        setError('Failed to fetch submissions');
      }
    } catch (err) {
      setError(err.message || 'Network error fetching submissions');
    } finally {
      setLoading(false);
    }
  }, [getAuthHeader]);

  const deleteSubmission = useCallback(async (id) => {
    setError(null);
    try {
      const response = await fetch(`${API_URL}/api/admin/submissions/${id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': getAuthHeader()
        }
      });
      
      if (response.ok) {
        setSubmissions(prev => prev.filter(s => s.id !== id));
        return true;
      }
      setError('Failed to delete submission');
      return false;
    } catch (err) {
      setError(err.message || 'Network error deleting submission');
      return false;
    }
  }, [getAuthHeader]);

  const updateSubmission = useCallback(async (id, updateData) => {
    setError(null);
    try {
      const response = await fetch(`${API_URL}/api/admin/submissions/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getAuthHeader()
        },
        body: JSON.stringify(updateData)
      });
      
      if (response.ok) {
        setSubmissions(prev => prev.map(s => 
          s.id === id ? { ...s, ...updateData } : s
        ));
        return true;
      }
      setError('Failed to update submission');
      return false;
    } catch (err) {
      setError(err.message || 'Network error updating submission');
      return false;
    }
  }, [getAuthHeader]);

  return {
    submissions,
    loading,
    error,
    fetchSubmissions,
    deleteSubmission,
    updateSubmission
  };
};

export default useSubmissions;
